class UsersProfileService {
  constructor() {
    'ngInject';

    this.editMode = {
      PreferredName: false,
      SecondaryEmail: false,
      HomeNumber: false,
      WorkNumber: false,
      Mobile: false,
      LanguagesSpoken: false,
      EmergencyContactName: false,
      EmergencyContactNumber: false,
      EmergencyContactNatureOfRelationship: false,
      BusinessAddress: false,
      HomeAddress: false,
      PostalAddress: false,
      Facebook: false,
      LinkedIn: false,
      Twitter: false,
      YoutubeFeatured: false,
      GooglePlaces: false,
      Instagram: false,
      GoogleMyBusiness: false,
      NotificationEmail: false,
    };

    this.editModeText = {
      PreferredName: 'Preferred First Name',
      SecondaryEmail: 'Secondary Email',
      HomeNumber: 'Home Phone',
      WorkNumber: 'Business Phone',
      Mobile: 'Mobile #',
      LanguagesSpoken: 'Language Spoken',
      EmergencyContactName: 'Emergency Contact Person',
      EmergencyContactNumber: 'Emergency Contact #',
      EmergencyContactNatureOfRelationship: 'Nature of Relationship',
      BusinessAddress: 'Business Address',
      HomeAddress: 'Home Address',
      PostalAddress: 'Postal Address',
      Facebook: 'Facebook',
      LinkedIn: 'Linked In',
      Twitter: 'Twitter',
      YoutubeFeatured: 'Youtube Featured',
      GooglePlaces: 'Google Maps',
      ConflictOfInterests: 'Conflicts of Interest',
      Instagram: 'Instagram',
      GoogleMyBusiness: 'Google My Business',
      OtherFees: 'Other fees',
      ShowClawBackClause: 'Show clawback clause',
      KiwiSaverAdvice: 'KiwiSaver advice',
      NotificationEmail: 'Notifications Email',
    };

    this.editModeKeys = {
      PreferredName: 'PreferredName',
      SecondaryEmail: 'SecondaryEmail',
      HomeNumber: 'HomeNumber',
      WorkNumber: 'WorkNumber',
      Mobile: 'Mobile',
      LanguagesSpoken: 'LanguagesSpoken',
      EmergencyContactName: 'EmergencyContactName',
      EmergencyContactNumber: 'EmergencyContactNumber',
      EmergencyContactNatureOfRelationship:
        'EmergencyContactNatureOfRelationship',
      BusinessAddress: 'BusinessAddress',
      HomeAddress: 'HomeAddress',
      PostalAddress: 'PostalAddress',
      Facebook: 'Facebook',
      LinkedIn: 'LinkedIn',
      Twitter: 'Twitter',
      YoutubeFeatured: 'YoutubeFeatured',
      GooglePlaces: 'GooglePlaces',
      ConflictOfInterests: 'ConflictOfInterests',
      Instagram: 'Instagram',
      GoogleMyBusiness: 'GoogleMyBusiness',
      OtherFees: 'OtherFees',
      ShowClawBackClause: 'ShowClawBackClause',
      KiwiSaverAdvice: 'KiwiSaverAdvice',
      NotificationEmail: 'NotificationEmail',
    };
  }

  getEditMode() {
    return this.editMode;
  }

  getEditModeText() {
    return this.editModeText;
  }

  getEditModeKeys() {
    return this.editModeKeys;
  }
}

export default UsersProfileService;
